import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { get } from 'lodash';
import cn from 'classnames';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import DropzoneInput from '../../components/DropzoneInput';
import { MEDIA_TAGS_TYPES_IDS, MEDIA_TYPES_IDS, TP } from '../../constants/consts';
import { useTranslation } from '../../src/i18n';
import { deleteEntity, getWholeList } from '../App/actions';
import { MEDIA } from '../../constants/endpointConstants';
import { deleteMediaAction, getMediaAction, uploadVenueImagesAction } from './actions';
import { colors } from '../../constants/styleConstants';
import { selectListData } from '../../store/selectors';
import { selectVenueModalDomain } from './selectors';
import { initialState } from './reducer';
import FbCircularProgress from '../../components/FbCircularProgress';
import ImageTag from '../../components/ImageTag';
import { joinMediaFormats } from '../../utils/editCommon';

const useStyles = makeStyles(theme => ({
  mediaImagesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  imageBlock: {
    position: 'relative',
  },
  mediaImage: {
    width: 150,
    padding: theme.spacing(1),
    display: 'flex',
    height: 150,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  closeIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    cursor: 'pointer',
    backgroundColor: colors.white,
    borderRadius: '50%',
  },
}));

export const getMedia = (dispatch, id) => {
  dispatch(
    getWholeList({
      endpoint: MEDIA,
      sagaRoutine: getMediaAction,
      params: {
        queryParams: {
          media_type_id: MEDIA_TYPES_IDS.IMAGE,
          media_tag_type_id: MEDIA_TAGS_TYPES_IDS.VENUE,
          media_tag_id: id,
        },
      },
    }),
  );
};

const MediaSection = ({ id, formats }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [deliting, setDeliting] = useState(false);
  const media = useSelector(selectListData(selectVenueModalDomain, initialState.media.listName));

  const uploadMediaImages = mediaImages => {
    setLoading(true);
    dispatch(
      uploadVenueImagesAction({
        images: mediaImages,
        venueId: id,
        callback: () => {
          getMedia(dispatch, id);
          setLoading(false);
        },
      }),
    );
  };

  const deleteMedia = mediaId => {
    setDeliting(true);
    dispatch(
      deleteEntity({
        endpoint: MEDIA,
        sagaRoutine: deleteMediaAction,
        id: mediaId,
        callback: () => {
          getMedia(dispatch, id);
          setDeliting(false);
        },
      }),
    );
  };

  return (
    <>
      <Grid item sm={12} xs={12}>
        {loading ? (
          <FbCircularProgress />
        ) : (
          <DropzoneInput
            type="image"
            accept={formats}
            onFileUpload={uploadMediaImages}
            className={classes.uploadDropzone}
            subtitle={t(`${TP}.FN_UPLOAD_FILE_FORMAT_TEMPLATE`, {
              format: joinMediaFormats(formats),
            })}
          />
        )}
      </Grid>
      {media && media.length > 0 && (
        <Grid item sm={12} xs={12} className={classes.mediaImagesContainer}>
          {media.map(mediaImage => {
            const mediaImageKey = get(mediaImage, 'id');
            const mediaSrc = get(mediaImage, 'file.urls.large');
            return (
              <div key={mediaImageKey} className={cn(classes.imageBlock, classes.mediaImage)}>
                {deliting ? (
                  <FbCircularProgress />
                ) : (
                  <>
                    <CloseIcon className={classes.closeIcon} onClick={() => deleteMedia(mediaImageKey)} />
                    <ImageTag className={classes.image} src={mediaSrc} alt={t(`${TP}.m_PHOTO`)} />
                  </>
                )}
              </div>
            );
          })}
        </Grid>
      )}
    </>
  );
};

MediaSection.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  formats: PropTypes.arrayOf(PropTypes.string),
};

export default MediaSection;
